export interface FeatureNode {
  id: number
  name: string
  code: string
  path?: string | null
  parentId?: number | null
  sortOrder: number
  icon?: string | null
  fontIcon?: string | null
  cssClass?: string | null
  hasBullet: boolean
  isSensitive: boolean
  isFuture: boolean
  isMenuItem: boolean
  permissionType: number
  renderType: number
  enabled: boolean
  isEnabled: boolean
  accessLevel?: number | null
  children: FeatureNode[]
}

export interface RoleWithMeta {
  id: string
  name: string
  normalizedName: string
  description?: string | null
  userType: string
  isSystem: boolean
  isClient: boolean
  userCount: number
  menuCount: number
}

export interface InternalUser {
  id: string
  name: string
  userId?: string | null
  email: string
  type: string
  currentRoleId?: string | null
  currentRoleName?: string | null
}

export interface FeaturePermissionInput {
  featureId: number
  isEnabled: boolean
  accessLevel?: number | null
}

export interface CreateInternalRolePayload {
  name: string
  description?: string
  permissions: FeaturePermissionInput[]
}

export interface FeatureFormPayload {
  name: string
  code?: string | null
  parentId?: number | null
  path?: string | null
  icon?: string | null
  fontIcon?: string | null
  cssClass?: string | null
  sortOrder: number
  permissionType: number
  renderType: number
  isMenuItem: boolean
  isSensitive: boolean
  isFuture: boolean
  hasBullet: boolean
  enabled: boolean
}

export interface ApiMessage {
  status: string
  text: string
  result?: string
}

export interface Pagination {
  page: number
  items_per_page: number
  total: number
  last_page: number
}

export const PermissionType = {
  Toggle: 0,
  AccessLevel: 1,
}

export const RenderType = {
  Link: 0,
  Submenu: 1,
  Section: 2,
  Widget: 3,
}

export const AccessLevel = {
  None: 0,
  View: 1,
  Edit: 2,
}

export interface UserFeatureState {
  featureId: number
  featureName: string
  featureCode: string
  isUserEnabled: boolean
  isRoleGranted: boolean
}

export interface UserFeatureInput {
  featureId: number
  isEnabled: boolean
}
